export default "__VITE_ASSET__7a9fdef5__"